import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import useSession from 'tennders-auth/hooks/useSession'

const PaymentTerms = () => {
  const { t } = useTranslation()
  const { user } = useSession()

  return (
    <div className="mt-18 mb-10">
      <h3 className="bold text-underline">
        {t('menus:paymentTerms')}
      </h3>
      {
        user?.company?.paymentTerms?.map((x) => (
          <p key={x.id}>
            <b>
              {`${x.type?.name}: `}
            </b>
            {x.days ? `${x?.days} ${t('menus:days')}` : null}
            {x.cmrType?.label ? (', ' + x.cmrType?.label) : ''}
            {x.discount > 0 ? (', ' + t('menus:discount', { discount: x.discount })) : ''}
            {x.summary ? `, ${x.summary}` : null}
          </p>
        ))
      }
    </div>
  )
}

export default PaymentTerms
